import {Value} from "./value";
import {UnitType} from "./unitType";

export class Degrees extends Value {
    constructor(value: number) {
        super(value, UnitType.ANGLES);
    }
}
